module.exports = "<form [ngClass]=\"{'form-horizontal': config.layout=='horizontal', 'form-inline': config.layout=='inline'}\">\n\t<ng-content></ng-content>\n</form>"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/ui/src/app/directives/input/c4-form.html
// module id = 1639
// module chunks = 2